export const DirectionType = {
    FROM_WORK: 'FROM_WORK',
    TO_WORK: 'TO_WORK',
    UNSET: 'UNSET',
};
